// Features Highlight Section
import { Check } from 'lucide-react';

export function Features() {

  return (
    <section id="features" className="py-16 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-green-600 text-center mb-12">
          Recursos ilimitados em todos os planos
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
              <Check className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900 mb-1">Emissão de notas fiscais</p>
              <p className="text-base text-gray-700">NFe, NFSe, NFCe - Produto e Serviço. Funciona em qualquer lugar do Brasil.</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
              <Check className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900 mb-1">Gestão financeira completa</p>
              <p className="text-base text-gray-700">Controle de contas a pagar e receber, fluxo de caixa e relatórios financeiros.</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
              <Check className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900 mb-1">Integração completa</p>
              <p className="text-base text-gray-700">Integração com marketplaces, lojas virtuais, PDV, logística e muito mais.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
